export class Plan {
	constructor (attributes) {
		var plan = attributes

		for (let key in plan) {
			this[key] = plan[key]
		}

		this.selected = false

		if (this.people === 2 && this.meals === 4) this.selected = true
		if (this.people === 4 && this.meals === 4) this.selected = true

		this.deliveryPrice = this.price >= 34 ? '0.00' : '5.90' 
	}
}
